import React from 'react'

function About() {
    return (
        <div className="about">
            <h1>About Us</h1>
            <p>Rayy-Docs is a Multi Device Online Word Processor and Text Editor with a Cloud Storage service which means , you can write any document with anyone Collaboratobly. 
                And your data is securely saved on a mongo server. 
                <br /><br />
                 This Web app is made with ReactJS, QuillJS, Socket.io, MongoDB etc. Hosted and Deployed on Netlify, Heroku and Mongo Atlas.<br />
                 created by <a href="https://sumonrayy.xyz">@sumonrayy</a> </p>
        </div>
    )
}

export default About
